// React Imports
import { useMemo } from 'react'

// Third-party Imports
import { useCookie } from 'react-use'

export const useObjectCookie = <T>(key: string, fallback?: T | null): [T, (newVal: T) => void] => {
  // Hooks
  const [valStr, updateCookie] = useCookie(key)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const value = useMemo<T>(() => (valStr ? JSON.parse(valStr) : fallback), [valStr])

  const updateValue = (newVal: T) => {
    // Persistente, non di sessione (Luca 2026-08-01): i browser MOBILE buttano
    // i session cookie alla chiusura — il tema chiaro/scuro (e ogni altra
    // impostazione Vuexy) deve sopravvivere alla riapertura, come già fa il
    // cookie della lingua.
    updateCookie(JSON.stringify(newVal), { expires: 365, path: '/', sameSite: 'lax' })
  }

  return [value, updateValue]
}
